var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthService } from '../../services/auth.service';
import { OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../../services/settings.service';
import { GPT_FEATURE, hasFeatureFlag } from '../../utilities/featureFlags';
import { getSideBarMenu } from './menu-items';
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(auth, router, settingsService) {
        this.auth = auth;
        this.router = router;
        this.settingsService = settingsService;
        this.showMenu = '';
        this.index = '';
        this.showSubMenu = '';
        this.showSubSubMenu = '';
        this.subIndex = '';
        this.initActionChat = false;
        this.botTestDropped = false;
        this.path = '';
        this.techTypes = [];
        this.techSelected = { value: 0, name: 'Default', class: 'tech-active-default' };
        this.toggleChatBot = new EventEmitter();
    }
    SidebarComponent.prototype.ngOnInit = function () {
        this.setTechTypes();
        this.path = this.router.url.split('admin')[1];
        this.getTechSandbox();
    };
    SidebarComponent.prototype.setTechTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureFlags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.auth.getFeatureFlags()
                        //techtypes
                    ];
                    case 1:
                        featureFlags = _a.sent();
                        //techtypes
                        this.techTypes = [{ value: 1, name: 'shared.headerNavigation.testBot.technology_df', class: 'tech-active-df' }];
                        if (hasFeatureFlag(GPT_FEATURE, featureFlags)) {
                            this.techTypes = this.techTypes.concat([
                                { value: 2, name: 'shared.headerNavigation.testBot.technology_gpt', class: 'tech-active-gpt' },
                                { value: 3, name: 'shared.headerNavigation.testBot.technology_hybrid', class: 'tech-active-hybrid' }
                            ]);
                        }
                        //sidebar
                        this.sidebarnavItems = getSideBarMenu(featureFlags).filter(function (sidebarnavItem) { return sidebarnavItem; });
                        return [2 /*return*/];
                }
            });
        });
    };
    SidebarComponent.prototype.ngOnChanges = function (changes) {
        this.getTechSandbox();
        if (this.showMiniSidebar) { }
    };
    SidebarComponent.prototype.getTechSandbox = function () {
        var _this = this;
        this.settingsService.getBotSettings()
            .subscribe(function (res) {
            _this.settings = res;
            if (res.sandboxTechnologyType) {
                var testTechType_1 = res.sandboxTechnologyType;
                _this.techSelected = _this.techTypes.find(function (tech) { return tech.value === testTechType_1; });
            }
        });
    };
    SidebarComponent.prototype.toggleDrop = function (event) {
        this.botTestDropped = event;
    };
    //[first level] This is to control opening and closing submenus
    SidebarComponent.prototype.addExpandClass = function (element, index) {
        this.index = index;
        if (element === this.showMenu && this.index === index) {
            this.showMenu = '0';
            this.index = '0';
        }
        else {
            this.showMenu = element;
        }
    };
    //[Second level] This is to control opening and closing submenus
    SidebarComponent.prototype.addActiveClass = function (element, index) {
        if (element === this.showSubSubMenu && element === this.showSubMenu) {
            this.showSubSubMenu = '0';
            this.showSubMenu = '0';
            this.subIndex = '0';
        }
        else {
            this.showSubMenu = element;
            this.showSubSubMenu = element;
            this.subIndex = index;
        }
    };
    SidebarComponent.prototype.validateButtonClass = function (tech) {
        if (this.initActionChat && this.techSelected.value === tech.value)
            return tech.class;
        return '';
    };
    SidebarComponent.prototype.toggleChat = function (tech) {
        var _this = this;
        this.botTestDropped = false;
        if (this.techSelected.value !== tech) {
            this.updateSanboxTech(tech);
            this.techSelected = this.techTypes.find(function (techType) { return techType.value === tech; });
            this.initActionChat = false;
            this.toggleChatBot.emit(this.initActionChat);
            setTimeout(function () {
                _this.initActionChat = true;
                _this.toggleChatBot.emit(_this.initActionChat);
            }, 500);
            return;
        }
        this.initActionChat = !this.initActionChat;
        this.toggleChatBot.emit(this.initActionChat);
    };
    SidebarComponent.prototype.updateSanboxTech = function (tech) {
        if (this.settings) {
            this.settingsService.updateBotSettings(__assign({}, this.settings, { sandboxTechnologyType: tech }))
                .subscribe(function (res) { });
            return;
        }
    };
    return SidebarComponent;
}());
export { SidebarComponent };
